import type { ComponentProps, ReactNode } from "react";

import { Modal } from "@similarweb/ui-components";

import { StyledModalTooltipGlobal } from "app/pages/sales-intelligence/common-components/styles";

import { CUSTOM_STYLES, StyledModalInner } from "./styles";

export type SignalsModalProps = Pick<ComponentProps<typeof Modal>, "isOpen" | "customStyles" | "onRequestClose"> & {
    children: ReactNode;
};

const SignalsModal = (props: SignalsModalProps) => {
    const { isOpen, customStyles, onRequestClose, children } = props;

    const customModalStyles = {
        overlay: { zIndex: 1120, ...customStyles?.overlay },
        content: { ...CUSTOM_STYLES.content, ...customStyles?.content },
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            customStyles={customModalStyles}
            shouldCloseOnOverlayClick={false}
            data-automation="signals-modal"
        >
            <StyledModalTooltipGlobal />

            <StyledModalInner>{children}</StyledModalInner>
        </Modal>
    );
};

export default SignalsModal;
